import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  Checkbox,
  useToast,
  VStack,
} from '@chakra-ui/react';
import { useState } from 'react';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export default function ModalInspeccion({ isOpen, onClose }: Props) {
  const [fecha, setFecha] = useState('');
  const [hora, setHora] = useState('');
  const [observaciones, setObservaciones] = useState('');
  const [evidencia, setEvidencia] = useState<File | null>(null);

  const [extintores, setExtintores] = useState(false);
  const [instalaciones, setInstalaciones] = useState(false);

  const toast = useToast();

  const handleGuardar = () => {
    if (!fecha || !hora || !observaciones) {
      toast({
        title: 'Faltan campos',
        description: 'Completa fecha, hora y observaciones',
        status: 'warning',
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    toast({
      title: 'Inspección guardada',
      description: 'Se han registrado los datos de inspección.',
      status: 'success',
      duration: 3000,
      isClosable: true,
    });

    // Aquí podrías pasar la data al padre si lo deseas

    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader
          bgImage="url('/img/bg.webp')"
          bgSize="cover"
          bgPosition="center"
          bgRepeat="no-repeat"
          color="white"
          textShadow="2px 2px 4px rgba(0,0,0,0.7)"
          fontWeight="bold"
          position="relative"
        >
          Inspección de Establecimiento
        </ModalHeader>
        <ModalCloseButton color="white" _hover={{ bg: 'rgba(255,255,255,0.2)' }} />
        <ModalBody>
          <VStack spacing={4} align="stretch">
            <FormControl isRequired>
              <FormLabel>Fecha de Inspección</FormLabel>
              <Input type="date" value={fecha} onChange={e => setFecha(e.target.value)} />
            </FormControl>

            <FormControl isRequired>
              <FormLabel>Hora de Inspección</FormLabel>
              <Input type="time" value={hora} onChange={e => setHora(e.target.value)} />
            </FormControl>

            <FormControl isRequired>
              <FormLabel>Observaciones / Hallazgos</FormLabel>
              <Textarea value={observaciones} onChange={e => setObservaciones(e.target.value)} />
            </FormControl>

            <FormControl>
              <FormLabel>Adjuntar Fotografías / Evidencia</FormLabel>
              <Input type="file" onChange={e => setEvidencia(e.target.files?.[0] || null)} />
            </FormControl>

            <FormControl>
              <FormLabel>Cumplimiento de normas de seguridad</FormLabel>
              <Checkbox isChecked={extintores} onChange={e => setExtintores(e.target.checked)}>
                Extintores y señalética
              </Checkbox>
              <Checkbox isChecked={instalaciones} onChange={e => setInstalaciones(e.target.checked)}>
                Instalaciones eléctricas y de gas
              </Checkbox>
            </FormControl>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button bg="#5b182b" color="white" _hover={{ bg: "#8a1f35" }} onClick={handleGuardar} mr={3}>
            Guardar Inspección
          </Button>
          <Button onClick={onClose}>Cerrar</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
